/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export type { Erc20 } from "./Erc20";
export type { Multicall2 } from "./Multicall2";
export * as factories from "./factories";
export { Erc20__factory } from "./factories/Erc20__factory";
export { Multicall2__factory } from "./factories/Multicall2__factory";
